module.exports = __webpack_public_path__ + "img/receipt.affff46f.png";